import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import Cookies from 'js-cookie';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { Post } from 'Xhr/Xhr';

export const GetEmrDocumentSummuryList = async (
  setDocumentSummaryList
) => {
  const IdPerson =
    Cookies.get('user') &&
    JSON.parse(Cookies.get('user'))?.IdPerson;

  setDocumentSummaryList('loading');

  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_PATIENT_EMR_DOCUMENT_SUMMARY_LIST}`,
    true,
    {
      IdPerson,
    }
  ).then((response) => {
    if (response.data.resCode === 1) {
      if (response.data.Data.lst.length > 0) {
        setDocumentSummaryList(
          response.data.Data.lst.map((el) => ({
            ItemContent: ArabicToPersian(el.FldName),
            ItemValue: el.FldId,
          }))
        );
      } else {
        setDocumentSummaryList(response.data.Data.lst);
      }
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
